import "./PelvicHealthPhysiotherapy.module.css";
import Header from "@/reusable_sections/Header";
import PelvicHealthHero from "./sections/PelvicHealthHero";
import AboutPelvicHealthPhysiotherapy from "./sections/AboutPelvicHealthPhysiotherapy";
import CommonConditionsWeTreat from "./sections/CommonConditionsWeTreat";
import WhatHappensAtYourAppointment from "./sections/WhatHappensAtYourAppointment";
import SpecialistPelvicHealthPhysiotherapist from "./sections/SpecialistPelvicHealthPhysiotherapist";
import WhyChooseAlignPhysiotherapy from "./sections/WhyChooseAlignPhysiotherapy";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function PelvicHealthPhysiotherapyPage() {
  return <div>
      <Header />
      <PelvicHealthHero />
      <AboutPelvicHealthPhysiotherapy />
      <CommonConditionsWeTreat />
      <WhatHappensAtYourAppointment />
      <SpecialistPelvicHealthPhysiotherapist />
      <WhyChooseAlignPhysiotherapy />
      <CallToAction />
      <Footer />
    </div>;
}